"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcFixedAssetRentals = class UcFixedAssetRentals extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    sortItems(...args) {
        return _.sortBy(args[0], p => (!this.isStale(p) ? "_" + p.service.name : p.service.name).toLowerCase() + p.id);
    }
    isStale(...args) {
        const [item] = args;
        return item.inactive ||
            (item.valid_to && this.$fn.parseISODate(item.valid_to) < this.today);
    }
    fixedAsset;
    onFixed_asset(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("fixedAsset");
    }
    items;
    async $$load_items() {
        return this.$fn.fetch('list_rental_assets', { parameters: { asset: this.fixedAsset.id } });
    }
    ux;
    dataMembers = ['items', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                items: null,
                ux: null,
            },
        };
    }
    async act_3343864469950044_emit_6796_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_3343864469950044_close_6795_getWhen($event) {
        return !!$event.data.modalResult.value;
    }
    async act_3343864469950044_showModal_6794_getActionArgs($event) {
        return {
            name: "RentalService",
            props: {
                meter: this.meter,
                assignToRental: true,
                preventEditMeter: true,
            },
        };
    }
    async evh_3343864469950044_clickPreventStop(event, scope) {
        return await this.actions.evh_3343864469950044_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_3343864469950044_emit_6796 = new core_1.actions.EmitAction({
            actionArgs: this.act_3343864469950044_emit_6796_getActionArgs,
            events: [],
        });
        const evh_3343864469950044_close_6795 = new core_1.actions.EventHandlerImpl({
            action: act_3343864469950044_emit_6796,
            event: "close",
            when: this.evh_3343864469950044_close_6795_getWhen,
            displayName: "emit",
        });
        const act_3343864469950044_showModal_6794 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_3343864469950044_showModal_6794_getActionArgs,
            events: [evh_3343864469950044_close_6795],
        });
        const evh_3343864469950044_clickPreventStop_6793 = new core_1.actions.EventHandlerImpl({
            action: act_3343864469950044_showModal_6794,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_3343864469950044_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3343864469950044_clickPreventStop_6793],
        });
        return {
            act_3343864469950044_emit_6796,
            evh_3343864469950044_close_6795,
            act_3343864469950044_showModal_6794,
            evh_3343864469950044_clickPreventStop_6793,
            evh_3343864469950044_clickPreventStop,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcFixedAssetRentals.prototype, "fixedAsset", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('fixedAsset'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcFixedAssetRentals.prototype, "onFixed_asset", null);
UcFixedAssetRentals = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcFixedAssetRentals);
exports.default = UcFixedAssetRentals;
vue_property_decorator_1.Vue.component("UcFixedAssetRentals", UcFixedAssetRentals);
